<template>
  <div class="step step_1" :class="{'form__step_hidden': step != number}" :aria-labelledby="`step${number}-title`">
    <h3 class="form__title"><span class="red">1 шаг.</span> Скачайте завление</h3>
    <div class="fileflex">
      <File filename="Заявление" filesize="271 KB" ext="pdf"/>
      <Btn tag="a" :href="download_url" target="_blank">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M2 21H22M12 19V2M12 19L9 16M12 19L15 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
        Скачать
      </Btn>
    </div>
    <p class="form__text">Вы можете отправить заявления для печати на личный e-mail</p>
    <LinkInput v-model="stepsdata[number][names[0]]" :isEmail="true" @send="send" :name="names[0]" text='E-mail для отправки'/>
    <h3 class="form__title"><span class="red">2 шаг.</span> Заполните и прикрепите подписаное завление</h3>
    <Droparea v-model="stepsdata[number][names[1]]" :multiple="true" :required="true" :name="names[1]"/>
    <div class="form__btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled() || step != number">Далее</Btn>
    </div>
  </div>
</template>

<script>
import File from './ui/File.vue';
import Btn from './ui/Btn.vue';
import LinkInput from './LinkInput.vue';
import Droparea from './Droparea.vue';
import { mapState } from 'vuex';
  export default {
    data: ()=>({
      infofired: false,
      download_url: '/change_insurance_form/img/statement.docx',
      errorcont: {},
      names: ['mail-statement','attachstatements[]']
    }),
    props: {
      number: {type: Number, default: 1}
    },
    methods: {
      send(){
        const formData = new FormData();

        const email = this.stepsdata[this.number][this.names[0]]
        const files = this.stepsdata[this.number][this.names[1]]
        
        formData.append('email', email)
        for (let i = 0; i < (files || []).length; i++)
          formData.append(`statement${i}`, files[i])
        
        fetch(`https://rosbankinsurance.ru/api/change-of-insurance/send-statement`, {
          method: 'POST',
          body: formData,
          mode: "no-cors",
          headers: {
            "Content-Type": undefined,
          },
        }).then(res => {
          if (res.ok) 
            this.$store.dispatch('throwSuccess', {
              title: 'Информация',
              text: 'Заявление успешно отправлено!<br><span class="popup__smtext">(Скорость доставки письма в редких случаях может доходить до 20 мин)</span>'
            })
          else 
            this.$store.dispatch('throwError', {
              title: 'Ошибка',
              text: `Что-то пошло не так! (Код ошибки: ${res.status})`,
              btn: 'Oк'
            })
        }).catch(()=>this.$store.dispatch('throwDefaultError'))
      },
      filled(){
        return this.stepsdata[this.number][this.names[1]]?.length
      },
    },
    computed:{
      ...mapState(['stepsdata','step'])
    },
    watch: {
      step(v) {
        if(v == this.number && !this.infofired) {
          this.infofired = true
          this.$store.dispatch('throwSuccess', {
            type: 'info',
            title: 'Информация',
            text: 'Для заполнения заявления Вам понадобится паспорт, номер&nbsp;ИНН, отчёт об оценке недвижимости (при наличии); необходимо будет скачать, распечатать, подписать и&nbsp;загрузить&nbsp;заявление на заключение договора страхования.<br> При наличии созаёмщиков необходимо будет заполнить на них анкеты данных и приложить копии паспортов'
          })
        }
      }
    },
    components: { File, Btn, LinkInput, Droparea }
}
</script>

<style lang="sass" scoped>
.fileflex
  display: flex
  justify-content: space-between
  .file
    width: auto
    flex-shrink: 1
    min-width: min-content
    margin-right: 20px
  &__actions
    pointer-events: none
    button
      pointer-events: auto
  .btn svg
    transform: translateX(-11px)
</style>